/**
 * 协议支付（payAgr）业务字典
 * 对应后端枚举：com.sunyard.allocation.business.payAgr.enums.*
 * 对应设计文档：docs/pay_agr/doc.md §3.2 / §4.2 / §7
 */
export const payAgrDict = {
    // 商户配置状态（config_status，String）
    configStatus: {
        PENDING: {color: '#faad14', label: '待审批'},
        APPROVED: {color: '#1890ff', label: '已审批'},
        REJECTED: {color: '#ff4d4f', label: '已拒绝'},
        PUSHING: {color: '#1890ff', label: '推送中'},
        EFFECTIVE: {color: '#52c41a', label: '已生效'},
        PUSH_FAIL: {color: '#ff4d4f', label: '推送失败'},
        INVALID: {color: '#8c8c8c', label: '已作废'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 订单状态（status，Integer）：0待执行 1待执行 2处理中 3完成 4服务费失败 5支付失败
    orderStatus: {
        0: {color: '#faad14', label: '待执行'},
        1: {color: '#faad14', label: '待执行'},
        2: {color: '#1890ff', label: '处理中'},
        3: {color: '#52c41a', label: '完成'},
        4: {color: '#ff7a45', label: '服务费失败'},
        5: {color: '#ff4d4f', label: '支付失败'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 执行记录状态（pay_agr_record.status，Integer）
    recordStatus: {
        0: {color: '#8c8c8c', label: '待执行'},
        1: {color: '#1890ff', label: '处理中'},
        2: {color: '#52c41a', label: '成功'},
        3: {color: '#ff7a45', label: '失败（可重试）'},
        4: {color: '#ff4d4f', label: '最终失败'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 任务类型（task_type）：1付款 2服务费
    taskType: {
        1: {color: '#1890ff', label: '付款'},
        2: {color: '#722ed1', label: '服务费'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 协议类型（agreement_type）
    agreementType: {
        PAYMENT: {color: '#1890ff', label: '支付协议'},
        WITHHOLD: {color: '#722ed1', label: '代扣协议'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 服务费收取类型（fee_type）：1比例 2固定金额
    feeType: {
        1: {color: '#1890ff', label: '比例'},
        2: {color: '#52c41a', label: '固定金额'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 支付类型（pay_type）
    payType: {
        PROTOCOL: {color: '#1890ff', label: '协议支付'},
        BALANCE: {color: '#8c8c8c', label: '余额支付（预留）'},
        default: {color: '#bfbfbf', label: '未知'},
    },
    // 服务费规则状态（pay_agr_fee_rule.status）
    feeRuleStatus: {
        0: {color: '#8c8c8c', label: '禁用'},
        1: {color: '#52c41a', label: '启用'},
        default: {color: '#bfbfbf', label: '未知'},
    },
};

/**
 * 通用取值辅助：getDictLabel(payAgrDict.orderStatus, 3) => '完成'
 */
export function getDictLabel(dict, value) {
    if (dict[value] !== undefined) {
        return dict[value].label;
    }
    return dict.default ? dict.default.label : '未知';
}

/**
 * 通用取色辅助：getDictColor(payAgrDict.orderStatus, 3) => '#52c41a'
 */
export function getDictColor(dict, value) {
    if (dict[value] !== undefined) {
        return dict[value].color;
    }
    return dict.default ? dict.default.color : '#bfbfbf';
}
